export interface Colors {
  [key: string]: string;
}

export interface PadColerElement {
  subtext: string;
  bg: string;
  border: string;
}

export type PadColorKeys = 'red' | 'pink' | 'orange' | 'yellow' | 'green' | 'blue' | 'purple';

export const padColors: Record<PadColorKeys, PadColerElement> = {
  red: {
    subtext: '#FF3131',
    bg: '#FFD5D5',
    border: '#FFB2B2'
  },
  pink: {
    subtext: '#F62490',
    bg: '#F7B3D6',
    border: '#F085B9'
  },
  orange: {
    subtext: '#F76D14',
    bg: '#F7D3B3',
    border: '#EFAF7E'
  },
  yellow: {
    subtext: '#B89500',
    bg: '#FFF9D9',
    border: '#EAD052'
  },
  green: {
    subtext: '#138800',
    bg: '#DFFFE2',
    border: '#9DE771'
  },
  blue: {
    subtext: '#0087CF',
    bg: '#D0F1FF',
    border: '#83DAFF'
  },
  purple: {
    subtext: '#4401FD',
    bg: '#E6DDFF',
    border: '#CDBBFF'
  }
};



export type VitalsColorKeys = 'neongreen' | 'neonblue' | 'neonyellow' | 'white' | 'grey';

export const vitalColors: Record<VitalsColorKeys, string> = {
  neongreen: "var(--brisby-green-neon, #0CF268)",
  neonblue: "var(--brisby-neon-blue, #0FF)",
  neonyellow: "var(--brisby-yellow-neon, #FFF500)",
  white: "var(--brisby-white, #FFFFFD)",
  grey: "var(--brisby-white, #B4A6AB)"
};
